import React from 'react'
import PropTypes from 'prop-types'

// Status/rank chips. `tone` carries colour, never meaning: the text always states it.

const TONE_CLASS = {
  neutral: 'gl-badge--neutral',
  success: 'gl-badge--success',
  accent: 'gl-badge--accent',
  gold: 'gl-badge--gold',
  silver: 'gl-badge--silver',
  bronze: 'gl-badge--bronze',
}

const Badge = ({ children, tone = 'neutral', shape = 'pill', ariaLabel, className = '' }) => (
  <span
    className={[
      'gl-badge',
      TONE_CLASS[tone] || TONE_CLASS.neutral,
      shape === 'circle' ? 'gl-badge--circle' : 'gl-badge--pill',
      className,
    ].filter(Boolean).join(' ')}
    // role="img" makes screen readers read the aria-label, so only set it when there is one.
    role={ariaLabel ? 'img' : undefined}
    aria-label={ariaLabel}
    >
    {children}
  </span>
)

Badge.propTypes = {
  children: PropTypes.node,
  tone: PropTypes.oneOf([ 'neutral', 'success', 'accent', 'gold', 'silver', 'bronze' ]),
  shape: PropTypes.oneOf([ 'pill', 'circle' ]),
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
}

export default Badge
